var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"8"}},_vm._l((_vm.socialNews),function(post){return _c('div',{key:post.id},[_c('social-news',{attrs:{"post":post}})],1)}),0),_c('b-col',{attrs:{"md":"4"}},[_c('recent-birthdate'),_c('events')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }